import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { AmazonRegisterFormBaseComponent } from '../../common/amazon-register-form-base.component';
import { HttpService } from '../../../../services/http.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SpinnerDialogComponent } from '../../../../dialogs/spinner-dialog/spinner-dialog.component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-amazon-register-form-ce-qa',
  templateUrl: '../../common/amazon-register-form.component.html',
  styleUrls: ['../../common/amazon-register-form.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AmazonRegisterFormCeQaComponent extends AmazonRegisterFormBaseComponent implements OnInit {
  // URL TBD
  endpoint = '/consumer/amazon/check-user-cepos';
  redirectUrl;
  spinner: MatDialogRef<SpinnerDialogComponent>;
  isProcessing = false;

  constructor(protected fb: FormBuilder,
              private route: ActivatedRoute,
              private router: Router,
              private http: HttpService,
              private dialog: MatDialog) {
    super(fb);
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.redirectUrl = params.redirectUrl;
      console.log(`redirectUrl = ${ this.redirectUrl }`);
    });
  }

  onSubmit($event): void {
    $event.preventDefault();
    $event.stopPropagation();

    if (!this.activationForm.valid) {
      console.log('Form is invalid. Please correct the errors.');
      return;
    }

    const formData = this.activationForm.value;

    const urlEncodedData = new URLSearchParams();
    urlEncodedData.append('firstName', formData.firstName);
    urlEncodedData.append('lastName', formData.lastName);
    urlEncodedData.append('email', formData.email);

    const infoField1 = formData.email;
    const infoField2 = formData.firstName;
    const infoField3 = formData.lastName;
    if (infoField1) {
      this.spinner = this.dialog.open(SpinnerDialogComponent, {
        panelClass: 'transparent',
        disableClose: true
      });
      const data = {
        operation: 'GetUserId',
        infoField1,
        infoField2,
        infoField3
      };

      const redirect = this.redirectUrl?.split('?')[0];
      const params = this.redirectUrl?.split('?')[1].split('&');
      console.log(`redirect = ${ redirect }, params = ${ params }`);
      this.http.checkAmazonUser(data).subscribe(res => {
        this.spinner.close();
        console.log(`res ${ JSON.stringify(res) }`);
        // tslint:disable-next-line:no-shadowed-variable
        const redirect = `${ this.redirectUrl }&infoField1=${ encodeURIComponent(formData.infoField1) }&infoField2=${ encodeURIComponent(formData.infoField2) }&infoField3=${ encodeURIComponent(formData.infoField3) }&userId=${ encodeURIComponent(res.userId) }`;
        console.log(` newUrl = ${ redirect }`);
        window.location.replace(redirect);
      }, err => {
        this.spinner.close();
      });
    }
  }

  onDblClick($event): void {
    $event.preventDefault();
    $event.stopPropagation();
    console.log('dblclick');
    return;
  }
}
